(function($) {
  var esr = function(options) {
    options = options || {};
    this.el = options.el || $('.search-results');
    this.options = options;

    // Internal variables
    this.is_dirty = false;
    this.search_timer = 0;
    this.apiUrl = this.options.apiUrl || '';
    this.url = this.options.url || '';
    this.filters_disabled = false;
    this.ajaxParameters = this.options.ajaxParameters || {__call: 'ElasticSearch'};
    this.contentTabs = this.options.contentTabs;

    // DOM elements
    this.list = $(".results-list",this.el);
    this.facetHolder = $(".search-filter",this.el);
    this.searchTermInput = $("input.search-term",this.el);
    this.sortSelect = $(".select-value.sort",this.el);
    this.clearLink = $(".clear-link",this.el);
    this.pagination = $(".pagination",this.el);
    this.statusMessage = $(".status-message",this.el);
    this.loadingOverlay = $(".loading",this.el);
    this.pagination = $(".pagination",this.el);
    this.formatOptions = $(".format-options",this.el);
    this.guidedLessons = $(".guided-lessons-container",this.el);
    this.searchTermDefaultText = 'Search entire library';

    // TODO: scope these selectors
    this.title = $(".title-area h1");
    this.description = $(".title-area p, .bottom-description p");
    this.contextualLinks = $(".title-area .contextual-links");

    //Content tabs ab test related
    this.contentTabsHolder = $('.content-type-tabs', this.el);

    // Setup the search filters
    this.setupFilters();

    // Add event listeners
    this.setupEvents();

    // Update the UI
    this.refreshFilters();

    // Set the initial page state
    if(window.history.replaceState) {
      window.history.replaceState(this.filter,document.title,window.location.href);
    }

    var logEvent ='pageload';
    if (window.Edu.queryString['cid'] === '11.74') {
      logEvent = 'topnav';
    }
    // Log the initial search
    this.logSearch(logEvent, true);
    // Other logs wait for the ajax request to finish, but for the inital search we want to log it right now
    this._sendSearchLogEvent();
  };
  esr.prototype = {
    getLogData: function() {
        var data = {
            search_identifier: this.analytics_search_id,
            q: this.filter.q,
            page: this.filter.page,
            sort: this.filter.sort
        };
        var facet;
        for(var i in this.filter.facets) {
            if(this.filter.facets.hasOwnProperty(i)) {
                facet = this.filter.facets[i];

                // Value different than default
                if(facet.selectedValues && facet.selectedValues.length !== facet.defaultValues.length) {
                    data[i] = JSON.stringify(facet.selectedValues);
                }
                else {
                    data[i] = '[]';
                }
            }
        }
        return data;
    },
    logSearch: function(trigger, generate_new_search_id) {
      if(generate_new_search_id) {
          this.analytics_search_id = Math.random().toString(36).substring(2,12);
      }

      var data = this.getLogData();
      data.trigger = trigger;

      // Queue up search log, but wait until we have results before logging
      this._log_search_data = data;
    },
    _sendSearchLogEvent: function() {
        // check for new premium content AB test conditions:
        if($('.premium-content').length) {
            // include in the test:
            if (window.Edu && window.Edu.trackEvent) {
                window.Edu.trackEvent('Has Premium Content',{

                },{
                    eventCategory: "worksheet",
                    eventAction: "premium content search results"
                });
            }
        }
        // end ab test edit

      if(!this._log_search_data) {
        return;
      }

      this._log_search_data.num_results = ($('.num-results',this.el).attr('data-num-results') || 0)*1;
      this._log_search_data.didyoumean = !!$('.did-you-mean',this.list).length;

      if(window.Edu && window.Edu.trackEvent) {
        window.Edu.trackEvent('Search',this._log_search_data);
      }
      this._log_search_data = null;


    },
    logResultClick: function(i, type, internalName) {
      if(window.Edu && window.Edu.trackEvent) {
        var data = this.getLogData();
        data.result_number = i;
        data.content_type = type;
        data.content_id = internalName;
        window.Edu.trackEvent('Search Click',data);
      }
    },
    setupFilters: function() {
      // Base filters take precedence over everything else
      this.base_filter = this.options.base_filter || {};

      // Default filter values
      var defaults = this.options.default_filter || {};

      // Holder for the current filter
      this.filter = {
        q: defaults.q || '',
        page: defaults.page || 1,
        typeahead: 0,
        resultsPerPage: defaults.resultsPerPage || 20,
        format: defaults.format || 'grid',
        sort: defaults.sort || 'dateCreated',
        types: defaults.types || [],
        facets: defaults.facets || []
      };

      // If there's a search term, default to relevance sort
      if(!defaults.sort && this.filter.q.length) {
        this.filter.sort = 'relevance';
        this.is_dirty = true;
      }

      this.defaultSort = this.options.default_sort || this.filter.sort;
    },
    setupEvents: function() {
      var self = this;
      var el = this.el;

      // Cancel any form submits
      this.el.on('submit',function(e) {
          e.preventDefault();

          self.is_dirty = true;
          self.filter.typeahead = 0;
          self.filter.page = 1;
          self.filter.q = el.find('input').val();

          if(self.filter.q.length) {
              self.filter.sort = 'relevance';
          } else {
              self.filter.sort = window.ElasticSearchResults.defaultSort;
          }
          self.refresh(true);
      });

      // On mousedown swap in the real href on disabled links (to prevent SEO crawl fatigue)
      this.el.on('mousedown','.facet-section a[data-href]', function() {
        $(this).attr('href', $(this).attr('data-href'));
      });

      this.el.on('click','.facet-section .toggle-collapse',function(e) {
        e.preventDefault();
        if($(this).parent().hasClass('show-collapsed')) {
          $(this).parent().removeClass('show-collapsed');
          $(this).text('See All');
        }
        else {
          $(this).parent().addClass('show-collapsed');
          $(this).text('See Fewer');
        }
      });


        //Content type tabs ab test
        this.el.on('click','.content-tabs .facet',function(e) {
            e.preventDefault();
            //Highlight the current tab if not more menu
            $('.content-tabs a', this.el).removeClass('active').removeClass('selected');
            $(this).addClass('active');
        });
        this.el.on('click','.more-menu .facet',function(e) {
            e.preventDefault();
            if(!$(this).parent().hasClass('disabled')) {
                $('.content-type-tabs .more-link').removeClass('open');
                $('.content-type-tabs .more-menu').removeClass('open');
            }
        });
        this.el.on('click','.content-type-tabs .more-link',function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('.content-type-tabs .more-menu').toggleClass('open');
            self.updateContentTypeTabs();
        });
        $(document).on('click', function(e){
            var t = $(e.target);
            if(!t.hasClass('more-link') && !t.closest('.more-link').length) {
                if ($('.content-type-tabs .more-menu') && $('.content-type-tabs .more-menu').hasClass('open')) {
                    $('.content-type-tabs .more-menu').removeClass('open');
                    $('.content-type-tabs .more-link').removeClass('open');
                }
            }
        });
        $(document).ready(function(){
            self.updateContentTypeTabs();
        });
        $(window).resize(function () {
            $('.content-type-tabs .content-tabs a').removeClass('hidden');
            self.updateContentTypeTabs();
        });

      this.el.on('click','.facet',function(e) {
        if(e) e.preventDefault();
        if(self.filters_disabled) return;

        // Cancel any pending searches
        window.clearTimeout(self.search_timer);
        self.search_timer = 0;

        // Get what type of facet this is (grade, subject, etc.)
        var type = $(this).attr('data-type');

        var facet = self.filter.facets[type];

        var value = $(this).attr('data-value');
        self.is_dirty = true;
        self.filter.typeahead = 0;
        self.filter.page = 1;

        facet.selectedValues = facet.selectedValues || [];
        facet.allowedValues = facet.allowedValues || [];

        var allowMultiple = facet.allowMultiple;

        //Disabling multiple selection content tab variation
          // Todo: Setting this for the Type facet in PHP
          if (type === 'types' && self.contentTabsHolder.length > 0) {
              allowMultiple = false;
          }
          if (type === 'types' && self.contentTabsHolder.length > 0 && value === 'all') { //Entire library selected. Don't add the type 'all'. Instead reset selected values.

              facet.selectedValues = [];
          }
          else {
              // If clicking on an already selected value, remove it
              if ($(this).hasClass('selected')) {
                  var new_values = [];
                  var to_remove = [value];

                  var internalName = $(this).attr('data-internal-name');

                  // Deselect all children
                  $('.facet[data-internal-name^="' + internalName + '."]', self.el).each(function () {
                      to_remove.push($(this).attr('data-value'));
                  });

                  // Select parent if there is one
                  if (internalName.match(/\./)) {
                      var parentInternalName = internalName.replace(/\.[^.]+$/, '');
                      var parent = $('.facet[data-internal-name="' + parentInternalName + '"]', self.el);
                      if (parent.length) {
                          new_values.push(parent.attr('data-value'));
                      }
                  }

                  for (var i = 0; i < self.filter.facets[type].selectedValues.length; i++) {
                      var test = facet.selectedValues[i];

                      if ($.inArray(test, new_values) >= 0) continue;
                      if ($.inArray(test, to_remove) >= 0) continue;
                      new_values.push(test);
                  }

                  facet.selectedValues = new_values;
              }
              // Otherwise, select the value
              else {
                  // If we allow multiple
                  // Or the user explicitly did shift+click or ctrl+click
                  if (allowMultiple || e.metaKey || e.ctrlKey || e.shiftKey) {
                      // If all the values are currently selected, set the new value to just this one
                      if (allowMultiple && facet.selectedValues.length == facet.allowedValues.length) {
                          facet.selectedValues = [value];
                      }
                      // Otherwise, add this selection to the current list
                      else {
                          facet.selectedValues.push(value);
                      }
                  }
                  // Single value at a time
                  else {
                      facet.selectedValues = [value];
                  }
              }
          }
        self.logSearch('filter',true);

        // Refresh results
        self.refresh(true);
      });

      // When the sort dropdown changes
      this.sortSelect.on('change',function() {
        // Cancel any pending searches
        window.clearTimeout(self.search_timer);
        self.search_timer = 0;

        // Update the filter
        var subject = $(this).attr('data-subject');
        self.is_dirty = true;
        self.filter.typeahead = 0;
        self.filter.page = 1;
        self.filter.sort = $(this).val();

        self.logSearch('sort',true);

        // Refresh results and scroll to top
        self.refresh(false,true);
      });

      // When the clear link is clicked
      this.clearLink.on('click',function(e) {
        if(e) e.preventDefault();
        self.clearFilters(true);
      });

      this.el.on('click','.remove-filter',function(e) {
        if(e) e.preventDefault();

        // Cancel any pending searches
        window.clearTimeout(self.search_timer);
        self.search_timer = 0;

        var type = $(this).attr('data-type');
        if(type == 'searchTerm') {
          self.filter.q = '';
          $('.search-term').val('');
        }
        else if(type.match(/^facet-/)) {
          var facet = type.replace(/^facet-/,'');

          var to_remove = $(this).attr('data-value');

          var new_values = [];
          $.each(self.filter.facets[facet].selectedValues,function(k,v) {
            if(v != to_remove) new_values.push(v);
          });
          self.filter.facets[facet].selectedValues = new_values;
        }
        else {
          return;
        }

        self.filter.typeahead = 0;
        self.filter.page = 1;
        self.is_dirty = true;

        self.logSearch('removefilter',true);

        self.refresh(true);
      });

      // When pagination links are clicked
      this.pagination.on('click','.links a, .page-links a, .page-link-prev, .page-link-next',function(e) {
        var el = $(this);
        if(el.hasClass('disabled') || el.hasClass('hide') || el.hasClass('active')){
          return;
        }
        if(e) e.preventDefault();

        // Cancel any pending searches
        window.clearTimeout(self.search_timer);
        self.search_timer = 0;

        var page = $(this).attr('data-page')*1;
        self.filter.page = page;
        self.is_dirty = true;

        // Refresh results and scroll to top
        self.refresh(true,true);
      });

      // When a "did you mean" term is clicked
      this.list.on('click','.did-you-mean a',function(e) {
        var term = $(this).attr('data-term');
        if(!term) return;
        e.preventDefault();

        self.filter.q = term;
        self.is_dirty = true;

        self.logSearch('didyoumean',true);

        self.refresh(true);
      });

      this.formatOptions.on('click','a',function(e) {
        e.preventDefault();
        if($(this).hasClass('selected')) return;
        self.filter.format = $(this).attr('data-format');
        self.is_dirty = true;

        // Refresh results and scroll to top
        self.refresh(false,true);
      });

      // Listen for state change events
      $(window).on('popstate',function(e) {
        // Cancel any pending searches
        window.clearTimeout(self.search_timer);
        self.search_timer = 0;

        if(window.history.state && window.history.state.page) {
          if(JSON.stringify(window.history.state) != JSON.stringify(self.filter)) {
            self.filter = window.history.state;
            self.is_dirty = true;

            self.logSearch('history',true);

            // Refresh results
            self.refresh(false,false);
          }
        }
      });
      // Click on a result (contextmenu is for right click -> open in new tab)
      // Not ideal to catch all right click events, but it's the best we can do
      $(this.list).on('click contextmenu','.result-link',function(e) {
        // Log this in redshift
        var $this = $(this);
        var i=$this.closest('.result').prevAll('.result').length+1;
        var type = $this.attr('data-type');
        var internalName = $this.attr('data-id');
        self.logResultClick(i, type, internalName);
      });
    },
    updateContentTypeTabs: function() {
        if (this.filter.facets.types && this.filter.facets.types.selectedValues && this.contentTabsHolder.length > 0) {
          var tabsContainer = $('.content-type-tabs .content-tabs')[0];
          //Check for overflown links
          var tabs = $('.content-type-tabs .content-tabs .facet');
          var selected = 'all';
          if (this.filter.facets['types'].selectedValues.length > 0 && this.filter.facets['types'].selectedValues.length !== this.filter.facets['types'].defaultValues.length) {
              selected = this.filter.facets['types'].selectedValues[0];
          }

          for (var i = tabs.length - 1; i >= 0; i--) {
              if (tabsContainer.scrollHeight > tabsContainer.offsetHeight || i > 4) { //overflown, or hit the max of 4 to be displayed at once
                  var val = $(tabs[i]).attr('data-value');
                  if (val === selected) {
                      continue;
                  } else {
                      $(tabs[i]).addClass('hidden');
                  }
              } else {
                  break;
              }
          }

          $('.content-tabs a', this.el).removeClass('active').removeClass('selected');
          var selectedLink = $('.content-type-tabs .content-tabs').find('[data-value=' + selected + ']');
          selectedLink.addClass('active').addClass('selected');

          //Update more menu
          $('.content-type-tabs .more-menu .facet').each(function (ind) {
              var val = $(this).attr('data-value');
              if ($('.content-type-tabs .content-tabs').find('[data-value=' + val + ']').hasClass('hidden')) {
                  $(this).css('display', 'block');
              } else {
                  $(this).css('display', 'none');
              }
          });

          if ($('.content-type-tabs .content-tabs a.hidden').length > 0) {
              //If there are hidden links show more link
              //Adjust the position - place it next to the right most
              var moreLink = $('.content-type-tabs .more-link');
              var rightMost = $('.content-type-tabs .content-tabs a').not('.hidden').last();
              var containerWidth = tabsContainer.offsetWidth;
              var rightPos = rightMost.position().left + rightMost.width() + 35;
              moreLink.css('left', rightPos + 'px');
              moreLink.addClass('visible');
              var moreMenu = $('.content-type-tabs .more-menu');
              var moreMenuRight = containerWidth - (moreLink.position().left);
              moreMenu.css('right', moreMenuRight + 'px');
          }
      }
    },
    clearFilters: function(addHistory) {
      // Reset search term
      this.filter.q = '';

      // Reset facets
      var self = this;
      $.each(this.filter.facets, function(k) {
        self.filter.facets[k].selectedValues = [];
      });

      // Sorting by relevance doesn't make sense for an empty search term
      if(this.filter.sort === 'relevance') this.filter.sort = this.defaultSort;

      this.filter.page = 1;
      this.filter.typeahead = 0;
      this.filter.types = [];

      this.is_dirty = true;

      self.logSearch('clearfilters',true);

      this.refresh(addHistory);
    },
    refresh: function(addHistory, scroll) {
      var self = this;

      this.refreshFilters();

      // Don't do the search unless the filters have changed
      if(!this.is_dirty) return;

      var params = $.extend({},this.filter,this.base_filter,this.ajaxParameters,true);

      if(!params.typeahead) {
        this.loadingOverlay.show();

        // Disable the filters while results are loading
        this.filters_disabled = true;
      }

      for(var i in params.facets) {
        params.facets[i] = params.facets[i].selectedValues;
      }

      // Some facets have their own special url parameters
      if(params.facets.grades) {
        params.grades = params.facets.grades;
        delete params.facets.grades;
      }
      if(params.facets.subjects) {
        params.subjects = params.facets.subjects;
        delete params.facets.subjects;
      }
      if(params.facets.types) {
        params.types = params.facets.types;
        delete params.facets.types;
      }

      // Check if the params.q is among in the types
      // This processes content types in the params.q as params.types instead
      var processedTypes = [];
      if(params.q) {
        for(var i in params.types) {
          if ((params.q).indexOf(params.types[i].replace("-", " ")) !== -1) {
            processedTypes.push(params.types[i]);
          }
        }
      }
      if (processedTypes.length) params.types = processedTypes;

      params.withAds = window.withAds;

      $.get(this.apiUrl,params,function(resp) {
        if(!resp.error && resp.filter) {
          if (window.intellimize) {
            window.intellimize.activate();
          }
          self.is_dirty = false;

          if(resp.filter) {
            self.filter.page = resp.filter.page;
            self.filter.facets = resp.filter.facets;
            self.filter.q = resp.filter.searchTerm;
            self.filter.format = resp.filter.format;
            self.filter.sort = resp.filter.sortField;
            self.filter.resultsPerPage = resp.filter.resultsPerPage;

            // Replace left facet html
            $(".facet-section",self.el).remove();
            $('hr', self.el).remove();
            var new_facet_html = $(resp.facetHTML);
            $(".search-results-box",self.el).after($(".facet-section",new_facet_html));
              if (self.contentTabsHolder.length > 0) {
              $('.content-type-tabs').replaceWith(resp.contentTypeTabsHTML);
              self.updateContentTypeTabs();
            }

            $('.facet-section',self.el).after($("<hr />"));

            // Replace current filters (e.g. "Current Filter (23 results): [reading|x] [preschool|x]")
            $(".current-filters-holder",self.el).html(resp.currentFiltersHTML);

            self.refreshFilters();
          }

          self.pages = Math.ceil(resp.totalResults/self.filter.resultsPerPage);
          self.refreshPagination();
          self.refreshPaginationNew();

          // Update title
          self.title.html(resp.meta.title);
          document.title = resp.meta.metaTitle;

          // Hide description on everything but fourth grade worksheets for SEO test
          self.description.text(resp.meta.description).hide();
          var regexWorksheets = /^worksheets\/fourth-grade/;
          if (regexWorksheets.test(resp.meta.url)) {
            self.description.show()
          }
          self.contextualLinks.hide();

          // Update meta description
          $("meta[name='description']").attr('content',resp.meta.metaDescription);

          // Update robots
          $("meta[name='robots']").attr('content',resp.meta.index? "index,follow":"noindex,follow");

          // Manage browser history if this isn't a typeahead refresh
          if(!params.typeahead) {
            if(addHistory && self.url && window.history.pushState) {
              window.history.pushState(self.filter,document.title,self.url+resp.url);
            }
            else if(self.url && window.history.replaceState) {
              window.history.replaceState(self.filter,document.title,self.url+resp.url);
            }
          }

          // Update guided lessons area
          self.guidedLessons.html(resp.guidedLessonsHTML.template ||'');

          // Update status message
          self.statusMessage.text(resp.statusMessage);

          // Store current ads
          var ads = $('.ad-result',self.list).detach();

          // Empty the results area
          self.list.html('');

          // Did You Mean suggestions
          if(resp.suggestions && resp.suggestions.length) {
            var dym = $("<div class='did-you-mean'></div>");
            dym.append('<span>Did you mean:</span> ');

            for(var i=0; i<resp.suggestions.length; i++) {
              if(i) dym.append(', ');

              dym.append($("<a>")
                .html(resp.suggestions[i].highlighted)
                .attr('data-term',resp.suggestions[i].text)
              );
            }

            self.list.append(dym);
          }

          // Put ads back into the search results at the proper spot
          var els = self.list.find('.result');
          ads.each(function() {
            var placement = $(this).attr('data-placement');
            if(placement >= els.length) {
              self.list.append($(this).addClass('extra-bottom'));
            }
            else {
              els.eq(placement).before($(this).removeClass('extra-bottom'));
            }
          });

          $(window).trigger('refreshAds');

          // Update format
          self.list.removeClass('grid list');

            // No results
            if(!resp.numResults) {
                if (resp.filter.facets.types.selectedValues.length == 1) {
                    self.list.append("<h2>Sorry, there are no results in " + self.options.nameMap[resp.filter.facets.types.selectedValues[0]].toLowerCase() + " for that search.</h2> You can ");
                }
                else {
                    self.list.append("<h2>Sorry, no results match your search.</h2> You can ");
                }
                self.list.append($("<a>").text('remove all filters').on('click', function () {
                    self.clearFilters();
                }));
                self.list.append(' and try again.');

            }
            else {
                // html for brainzy driver when results gets re-rendered
                if (window.brainzyDriverVariation) {
                    var gradeFilter = self.filter.facets.grades.selectedValues[0];
                    gradeFilter = ((gradeFilter !== undefined) ? gradeFilter : '');

                    // finding relevant selected filter to display correct image
                    var baseSubject = '';
                    $('.selected').each(function() {
                        var dataSubject = $(this).attr('data-internal-name');
                        if (dataSubject === 'math' || dataSubject === 'ela' || dataSubject === 'typing') {
                            baseSubject = dataSubject;
                        }
                    });

                    // deep linking into correct map
                    var guidedLessonUrl = '/games/play/';
                    if(baseSubject && gradeFilter) {
                        guidedLessonUrl = guidedLessonUrl + '#' + baseSubject + ',' + baseSubject;
                        if (baseSubject !== 'typing') {
                            guidedLessonUrl = guidedLessonUrl + '-' + gradeFilter.replace('-grade','');
                        }
                    }

                    var brainzyDriverClass = 'brainzy-driver ' + ((gradeFilter) ? 'grade' : '') + ' ' + baseSubject;
                    var mapClass = 'map ' + gradeFilter + ' ' + baseSubject;

                    if (baseSubject === 'typing') {
                        gradeFilter = '';
                    } else {
                        gradeFilter = gradeFilter.charAt(0).toUpperCase() + gradeFilter.slice(1);
                    }

                    if (baseSubject === 'ela') {
                        baseSubject = baseSubject.toUpperCase();
                    }

                    if (!gradeFilter) {
                        baseSubject = baseSubject.charAt(0).toUpperCase() + baseSubject.slice(1);
                    }

                    var brainzyDriver =
                        $("<div class=\""+brainzyDriverClass+"\">" +
                            "<div class='driver-inner-container'>" +
                                "<div class='info'>" +
                                    "<a href=\""+guidedLessonUrl+"\" target='_blank'><img src='/files/static/Brainzy/brainzy-logo-rainbow.png'/></a>" +
                                    "<div class='grade filter'>"+gradeFilter.replace(/-/g," ")+"</div>" +
                                    "<div class='subject filter'>"+baseSubject+"</div>" +
                                    "<div class='type filter'>games</div>" +
                                    "<a href=\""+guidedLessonUrl+"\" target='_blank'><div class='btn btn-secondary'><i class='icon-play'></i> Play</div></a>" +
                                "</div>" +
                                "<a href=\""+guidedLessonUrl+"\" target='_blank'><div class=\""+mapClass+"\"></div></a>" +
                            "</div>" +
                        "</div>");

                    self.list.append(brainzyDriver);
                }

                self.list.append(resp.html);
                self.list.addClass(self.filter.format);
                self.list.lazyload();
                $(window).trigger('renderContentCards');
            }

          self.formatOptions.find('a').removeClass('selected');
          self.formatOptions.find('a[data-format="'+self.filter.format+'"]').addClass('selected');
        }
        else {
          self.list.html("<div class='alert alert-error'><strong>Unexpected Error:</strong> "+
            "Please try again in a few minutes and email support@education.com if you continue to experience issues. "+
            "We're sorry for any inconvenience."+
          "</div>");
          if(window.console && window.console.log) {
            console.log('error searching',resp);
          }
        }

        // Hide loading overlay
        self.loadingOverlay.hide();

        if(scroll) {
          // Scroll up to first result if we're already scrolled past it or too far up
          var target = self.el.offset().top - 5;
          if(target > $("body").scrollTop()) {
            // If this is a popstate refresh, scroll quicker
            // Because of browser behavior, we can't scroll immediately, so there still needs ot be some delay
            var delay = addHistory? 500 : 10;

            $('html,body').animate({
              scrollTop: target
            },delay);
          }
        }

        // Track the search
        self._sendSearchLogEvent();

        // Re-enable the filters
        self.filters_disabled = false;
      }).fail(function() {
        self.list.html("<div class='alert alert-error'>There was an error searching for lesson plans.</div>");

        // Hide the loading overlay and mobile filters
        self.loadingOverlay.hide();
        if($(".search-filter.open").length) {
          $(".search-filter.open .mobile-tab").trigger('click');
            if ($('.search-filter.open .close-filter').length > 0) {
                $('.search-filter.open .close-filter').trigger('click');
            }
        }

        // Re-enable the filters
        self.filters_disabled = false;
      });
    },
    refreshFilters: function() {
      var searchTerm = '';
      //Display a single content type if not all content types are shown.
      if (this.filter.facets.types && this.filter.facets.types.selectedValues
        && this.filter.facets.types.selectedValues.length < this.filter.facets.types.allowedValues.length
        && this.filter.facets.types.selectedValues[0] && this.options.nameMap[this.filter.facets.types.selectedValues[0]]) {
        searchTerm = 'Search ' + this.options.nameMap[this.filter.facets.types.selectedValues[0]].toLowerCase();
      }
      else {
        searchTerm = this.searchTermDefaultText;
      }
      this.searchTermInput.attr('placeholder', searchTerm).val('');

      // Update the sort dropdown
      this.sortSelect.val(this.filter.sort);
    },

    refreshPagination: function() {
      var holder = $(".links",this.pagination).empty();

      var start, end;
      if(this.filter.page > 6) {
        start = this.filter.page - 5;
        end = Math.min(this.filter.page + 4, this.pages);
      }
      else {
        start = 1;
        end = Math.min(10,this.pages);
      }

      // Update pagination counter
      this.pagination.attr('data-pages',this.pages);

      // Add pagination links
      for(var i=start; i<=end; i++) {
        var el;
        if(i === this.filter.page) {
          el = $("<span class='current'>").text(i);
        }
        else {
          el = $("<a>")
            .attr('href','?page='+i)
            .attr('data-page',i)
            .text(i);
        }
        holder.append(el);
      }
    },

    refreshPaginationNew: function() {
      var prev_holder = $(".page-link-prev",this.pagination);
      var next_holder = $(".page-link-next",this.pagination);
      var holder = $(".page-links",this.pagination).empty();

      var page_cap = Math.floor(9999/this.filter.resultsPerPage);
      page_cap -= page_cap % 100;

      if(this.pages > page_cap) {
        this.pages = page_cap;
      }

      var start, end;
      if(this.filter.page > 3 && this.pages > 5) {
        start = this.filter.page - 2;
        end = Math.min(this.filter.page + 2, this.pages);
      }
      else {
        start = 1;
        end = Math.min(5,this.pages);
      }

      // Update pagination counter
      this.pagination.attr('data-pages',this.pages);

      // Add pagination links
      var el;
      var prev;
      var next;

      if(this.pages > 1) {
        prev = $("<a>").attr('href', 'page='+(this.filter.page - 1)).attr('data-page', this.filter.page - 1).addClass('page-link-prev').removeClass('disabled').removeClass('hide').html("<i class='icon-left'></i>");
        if(this.filter.page === 1) {
          prev.addClass('disabled');
        }
        next = $("<a>").attr('href', 'page='+(this.filter.page + 1)).attr('data-page', this.filter.page + 1).addClass('page-link-next').removeClass('disabled').removeClass('hide').html("<i class='icon-right'></i>");
        if(this.filter.page === this.pages) {
          next.addClass('disabled');
        }
      } else {
        prev = $("<a>").attr('href', '#').attr('data-page', '#').removeClass('disabled').addClass('page-link-prev').addClass('hide').html("<i class='icon-left'></i>");
        next = $("<a>").attr('href', '#').attr('data-page', '#').removeClass('disabled').addClass('page-link-next').addClass('hide').html("<i class='icon-right'></i>");
      }
      prev_holder.replaceWith(prev);
      next_holder.replaceWith(next);

      if(this.pages > 11) {
        if(this.filter.page > 3) {
          el = $("<a>").attr('href','?page=1').attr('data-page',1).text(1);
          holder.append(el);
        }
        if(this.filter.page > 4) {
          el = $("<a>").attr('href','?page=2').attr('data-page',2).text(2);
          holder.append(el);
        }
        if(this.filter.page > 5) {
          el = $("<span>").text("...");
          holder.append(el);
        }
        if(this.filter.page === this.pages) {
          el = $("<a>").attr('href','?page='+(this.pages-5)).attr('data-page',this.pages-5).text(this.pages-5);
          holder.append(el);
        }
        if(this.filter.page >= this.pages - 1) {
          el = $("<a>").attr('href','?page='+(this.pages-4)).attr('data-page',this.pages-4).text(this.pages-4);
          holder.append(el);
        }
      } else if(this.pages > 5) {
          if(this.filter.page >= this.pages - 1) {
              el = $("<a>").attr('href','?page='+(this.pages-4)).attr('data-page',this.pages-4).text(this.pages-4);
              holder.append(el);
          }
          if(this.filter.page === this.pages) {
              el = $("<a>").attr('href','?page='+(this.pages-3)).attr('data-page',this.pages-3).text(this.pages-3);
              holder.append(el);
          }
      }

      for(var i=start; i<=end; i++) {
        if(i === this.filter.page) {
            el = $("<a class='active'>").text(i);
        }
        else {
            el = $("<a>").attr('href','?page='+i).attr('data-page',i).text(i);
        }
        holder.append(el);
      }

      if(this.pages > 11) {
        if(this.filter.page < this.pages - 4) {
          el = $("<span>").text("...");
          holder.append(el);
        }
        if(this.filter.page < this.pages - 3) {
          el = $("<a>").attr('href','?page='+(this.pages-1)).attr('data-page',this.pages-1).text(this.pages-1);
          holder.append(el);
        }
        if(this.filter.page < this.pages - 2) {
          el = $("<a>").attr('href','?page='+(this.pages)).attr('data-page',this.pages).text(this.pages);
          holder.append(el);
        }
      }
    }
  };

  if(window.ElasticSearch && window.ElasticSearch[0]) {
    window.ElasticSearchResults = new esr(window.ElasticSearch[0]);
    $(document).trigger('search-ready');
  }

  window.ElasticSearch = {
    push: function(options) {
      window.ElasticSearchResults = new esr(options);
      $(document).trigger('search-ready');
    }
  };

  // Hook up mobile filter tab
  $(".search-results .filters-btn-mobile").on('click', function (e) {
    e.preventDefault();

    var filter = $(this).closest('.search-results').find('.search-filter');
    if (filter.hasClass('open')) {
      filter.removeClass('open');

      // Hide modal
      if (window.Edu.overlay) window.Edu.overlay.fadeOut(500);

      // Remove input focus from the filters when closing
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }
    else {
      filter.addClass('open');

      // Show modal
      if (window.Edu.overlay) window.Edu.overlay.fadeIn(500);
    }
  });

  var vipKidsElement = document.getElementById('vipkid-custom-ad');
  // Checking if the VipKids custom ad is shown
  if(vipKidsElement && document.body.contains(vipKidsElement)) {
    if(window.Edu && window.Edu.trackEvent) {
      window.Edu.trackEvent('vipkids', {
        label: 'inline-ad-search-results',
        action: 'custom-ad-is-shown'
      });
    }
  }

  // VipKids link tracking (click event)
  $('#vip-direct-link').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if(window.Edu && window.Edu.trackEvent) {
      window.Edu.trackEvent('vipkids', {
        label: 'inline-ad-search-results',
        action: 'ad-clicked'
      });
    }

    if ($(this).attr('href')) {
      window.open($(this).attr('href'), '_blank');
    }
  });

  $.ajaxSetup({cache:true});
  var onTypeaheadLoad = function() {
    var searchForm = $('.search-form:not(.nav-search-form)');
    var submitSearchbButton = $('button[type=submit]', searchForm);
    var typeAheadInput = $('input.typeahead[type=search]', searchForm);

    var dataList = new Bloodhound({
      datumTokenizer: function(d) { return Bloodhound.tokenizers.whitespace(d.display); },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      prefetch: {
        url: '/api/auto-complete/data-list/all',
        cache: true
      }
    });

    dataList.initialize();

    typeAheadInput.typeahead({
      highlight: true,
      minLength: 1
    },{
      limit: window.ElasticSearchResults.typeaheadMaxResults,
      name: 'dataList',
      source: dataList.ttAdapter(),
      display: 'display',
      templates: {
        suggestion: function(data) {
          return ('<p data-term="' + data.term + '" data-display="' + data.display + '">' + (data.display).replace(data._query, '<strong>' + data._query + '</strong>') + '</p>');
        }
      }
    });

    typeAheadInput.bind('keydown', function(e) {
      if(e.which === 13) {
        e.preventDefault();
        var termFound = false;
        $.each($('.tt-dataset-dataList p.tt-suggestion'), function(i, el) {
          if (typeAheadInput.val() === $(el).data().display || typeAheadInput.val() === $(el).data().term) {
            termFound = true;
            performSearch($(el).data().term, true);
          }
        }).promise().done( function() {
          if (!termFound) {
            performSearch(typeAheadInput.val(), false);
          }
        });
      }
    });

    typeAheadInput.bind('typeahead:select', function(e, suggestion) {
      performSearch(suggestion.term, true);
    });

    function performSearch(originalSearchTerm, autocompleteUsed) {
      // Cancel any pending typeahead requests
      window.clearTimeout(window.ElasticSearchResults.search_timer);
      window.ElasticSearchResults.search_timer = 0;

      // Strip out "%20" and similar encoding
      var searchTerm = decodeURIComponent(originalSearchTerm)
      // Replace '/' or '+' with space
        .replace(/[/+]/g,' ')
        // Trim whitespace
        .replace(/(^\s+|\s+$)/g,'');

      // Treat the string 'null' as an empty string
      if(searchTerm == 'null') searchTerm = '';

      // If the sanitized string is different from what was entered, update the input box
      if(searchTerm !== originalSearchTerm) {
        searchTerm = originalSearchTerm;
        $(typeAheadInput).val(searchTerm);
      }

      // Update the filter
      window.ElasticSearchResults.is_dirty = true;
      window.ElasticSearchResults.filter.typeahead = 0;
      window.ElasticSearchResults.filter.page = 1;
      window.ElasticSearchResults.filter.q = searchTerm;

      if(window.ElasticSearchResults.filter.q.length) {
        window.ElasticSearchResults.filter.sort = 'relevance';
      }
      else {
        window.ElasticSearchResults.filter.sort = window.ElasticSearchResults.defaultSort;
      }

      if (autocompleteUsed) window.ElasticSearchResults.logSearch('autocomplete', true);
      window.ElasticSearchResults.refresh(true);

      // Always close the autocomplete when a search is performed
      typeAheadInput.typeahead('close');
    }
  };
  if(jQuery.fn.typeahead) {
    onTypeaheadLoad();
  }
  else {
    jQuery(document).on('typeaheadLoaded', onTypeaheadLoad);
  }

})(window.jQuery);
